import { typeOf, isJson } from "../tool/func";
import { isAndroid, isIos, isHarmony } from "../tool/assert";

const jsonHacKeys = ["mddBridgeRequest"];

// 执行方法通知app(Android)
const runAndroidFunction = (key, params) => {
  if (window.app && typeOf(window.app[key]) === "function") {
    params ? window.app[key](params) : window.app[key]();
    return window.app && window.app[key];
  }
};

// 执行方法通知app(Ios)
const runIosFunction = (key, params) => {
  const messager = window.webkit && window.webkit.messageHandlers;
  messager && messager[key] && messager[key].postMessage(params);
  return messager && messager[key];
};

// 根据不同系统执行上面的Android或IOS的方法
const runFunction = (funcKey, params, resolve) => {
  if (isAndroid || isHarmony) {
    runAndroidFunction(funcKey, params) || (resolve && resolve(null));
  } else if (isIos) {
    runIosFunction(funcKey, params || {}) || (resolve && resolve(null));
  } else {
    resolve && resolve(null);
  }
};

// app交互方法通用处理函数(ios、Android)
export const appFunction = function (funcKey, cbKey, params) {
  // 判断是方法为空
  // if (funcKey == null) return;

  // 判断是否定义了callback
  if (cbKey == null) return runFunction(funcKey, params);

  return new Promise((resolve) => {
    //如果定义并原型上存在函数队列，则推入一个回调
    //否则，定义callback，并在原型上定义fnList函数队列（含首个回调）
    const callback = window[cbKey];
    const func = function (res) {
      // 处理Android桥接数据字符串里面的转义字符
      // console.log(typeof res ==='string',jsonHacKeys.includes(funcKey),res)

      if (jsonHacKeys.includes(funcKey) && typeof res === "string") {
        res = res.replace(
          /[\f\n\r\t\v\u00a0\u1680\u180e\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]/gi,
          ""
        );
      }
      // 处理Android和ios某些返回结果数据类型不一致问题，ios->对象，Android->json字符串
      isJson(res) && (res = JSON.parse(res));
      resolve(res);
    };
    if (callback && Array.isArray(callback.prototype.fnList)) {
      callback.prototype.fnList.push(func);
    } else {
      window[cbKey] = function (cbRes) {
        const fnList = window[cbKey].prototype.fnList;
        // 队列为空，返回
        if (fnList == null || fnList.length <= 0) return;
        // console.log('客户端执行回调');
        // 执行回调队列
        window[cbKey].prototype.fnList.forEach((fn) => fn(cbRes));
        // 执行完成立即清空队列
        window[cbKey].prototype.fnList = [];
      };
      // 原型上定义函数队列fnList，添加第一个函数
      window[cbKey].prototype.fnList = [func];
    }
    funcKey && runFunction(funcKey, params, resolve);
  });
};

// 单纯注册回调事件
export const registerCallback = (cbKey, cbFunc) => {
  const callback = window[cbKey];
  if (callback && Array.isArray(callback.prototype.fnList)) {
    callback.prototype.fnList.push(cbFunc);
  } else {
    window[cbKey] = function (cbRes) {
      const fnList = window[cbKey].prototype.fnList;
      // 队列为空，返回
      if (fnList == null || fnList.length <= 0) return;
      // console.log('客户端执行回调');
      // 执行回调队列
      window[cbKey].prototype.fnList.forEach((fn) => fn(cbRes));
      // 执行完成立即清空队列
      // window[cbKey].prototype.fnList = []
    };
    // 原型上定义函数队列fnList，添加第一个函数
    window[cbKey].prototype.fnList = [cbFunc];
  }
};
